import React, { useState } from 'react'
import { useQuery, gql } from '@apollo/client'
import { Box, Grid, Dialog, DialogContent, IconButton, Typography, CircularProgress } from '@mui/material'
import { Close, Image as ImageIcon } from '@mui/icons-material'
import { getStopPhotos } from '../../apollo/queries'

const GET_STOP_PHOTOS = gql`
  ${getStopPhotos}
`

const PodPhotos = ({ jobId, stopId, orderId }) => {
  const [selectedImage, setSelectedImage] = useState(null)
  const [dialogOpen, setDialogOpen] = useState(false)

  const { loading, error, data } = useQuery(GET_STOP_PHOTOS, {
    variables: { jobId, stopId },
    skip: !jobId || !stopId,
    fetchPolicy: 'cache-and-network'
  })

  if (!jobId || !stopId) {
    return null
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
        <CircularProgress size={16} />
        <Typography variant="caption" color="text.secondary">
          Loading photos...
        </Typography>
      </Box>
    )
  }

  if (error) {
    console.error('Error loading POD photos:', error)
    return null
  }

  const photos = data?.getStopPhotos || []

  if (photos.length === 0) {
    return null
  }

  const handleImageClick = (photo) => {
    setSelectedImage(photo)
    setDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
    setSelectedImage(null)
  }

  return (
    <>
      <Box sx={{ mt: 1 }}>
        <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1, color: 'text.secondary' }}>
          <ImageIcon sx={{ fontSize: 14 }} />
          Proof of Delivery ({photos.length})
        </Typography>
        <Grid container spacing={1}>
          {photos.map((photo) => (
            <Grid item key={photo._id}>
              <Box
                onClick={() => handleImageClick(photo)}
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: 1,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  border: '1px solid #e0e0e0',
                  '&:hover': {
                    border: '1px solid #00b894',
                    boxShadow: 2
                  }
                }}
              >
                <img
                  src={photo.url}
                  alt={photo.fileName || 'POD Photo'}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                  onError={(e) => {
                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiBmaWxsPSIjRjVGNUY1Ii8+CjxwYXRoIGQ9Ik00MCAzMEMzNS4wMjk0IDMwIDMxIDM0LjAyOTQgMzEgMzlDMzEgNDMuOTcwNiAzNS4wMjk0IDQ4IDQwIDQ4QzQ0Ljk3MDYgNDggNDkgNDMuOTcwNiA0OSAzOUM0OSAzNC4wMjk0IDQ0Ljk3MDYgMzAgNDAgMzBaTTQwIDUyQzMyLjI2ODAgNTIgMjYgNTguMjY4IDI2IDY2VjY4SDU0VjY2QzU0IDU4LjI2OCA0Ny43MzIgNTIgNDAgNTJaIiBmaWxsPSIjQ0NDQ0NDIi8+Cjwvc3ZnPgo='
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: 'rgba(0, 0, 0, 0.9)',
            maxHeight: '90vh'
          }
        }}
      >
        <DialogContent sx={{ p: 0, position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
          <IconButton
            onClick={handleCloseDialog}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              color: 'white',
              bgcolor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': {
                bgcolor: 'rgba(0, 0, 0, 0.7)'
              },
              zIndex: 1
            }}
          >
            <Close />
          </IconButton>
          {selectedImage && (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
              <img
                src={selectedImage.url}
                alt={selectedImage.fileName || 'POD Photo'}
                style={{
                  maxWidth: '100%',
                  maxHeight: '80vh',
                  objectFit: 'contain'
                }}
                onError={(e) => {
                  e.target.style.display = 'none'
                }}
              />
              {selectedImage.fileName && (
                <Typography variant="caption" sx={{ color: 'white', mt: 1 }}>
                  {selectedImage.fileName}
                </Typography>
              )}
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}

export default PodPhotos



